<!-- <div class="container">
  <dismissible-alert page-id="RetirementPlanDocuments" is-global="1"></dismissible-alert>
  <mega-menu type="BA"></mega-menu>
</div> -->
<div id="retirement-plan-documents">
  <div class="row">
    <div class="col-xs-12">
      <h3 class="title">Retirement Plan Documents - Distribution Confirmation</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="vspacer vspacer-lg"></div>
      <div class="panel panel-default">
        <div class="panel panel-default">
          <h3 style="padding: 10px" class="confirmation-message">
            <span class="glyphicon glyphicon-ok-sign text-success pull-left"></span>
            <span class="text-success">
              Your acknowledgement was successfully sent on {{ TodaysDate }}.
            </span>
            <span class="pull-right">
              <a href="javascript:void(0);" class="btn btn-link">
                <span class="icon-utility-print"></span>
              </a>
            </span>
          </h3>
          <h5>DISTRIBUTION DETAILS</h5>
          <div style="padding-bottom: 10px">
            <div>
              Date Distributed:
              {{processedDistributions[0]?.DistributionDate | date : "M/dd/yyyy"}}
            </div>
            <div>
              Your Method of Distribution:
              {{ processedDistributions[0]?.MethodOfDelivery }}
            </div>
            <div>
              Comments:
              {{
                processedDistributions[0]?.Comments
                  ? processedDistributions[0]?.Comments
                  : "N/A"
              }}
            </div>
            <br />
          </div>
          <div *ngIf="!processedDistributions[0]?.HasSh">
            <h5>PLAN PARTICIPANTS</h5>
            <table class="table">
              <thead>
                <tr>
                  <th style="cursor: pointer; width: 37%">SUBGROUP &nbsp;</th>
                  <th
                    style="
                      width: 23%;
                      cursor: pointer;
                      padding: 12px 5px !important;
                    "
                    class="borderLeft"
                  >
                    PLAN DOCUMENT &nbsp;
                  </th>
                  <th
                    style="
                      cursor: pointer;
                      width: 20%;
                      text-align: left;
                      padding: 12px 5px !important;
                    "
                  >
                    DOCUMENT TYPE &nbsp;
                  </th>
                  <th
                    style="
                      width: 20%;
                      cursor: pointer;
                      text-align: left;
                      padding: 12px 5px !important;
                    "
                  >
                    #PARTICIPANTS &nbsp;
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of processedDistributions">
                  <td>{{ item.ProcessedAcknowledgement.SubgroupName }}</td>
                  <td style="padding: 12px 5px !important">
                    {{ item.ProcessedAcknowledgement.PlanDocument }}
                  </td>
                  <td style="padding: 12px 5px !important; text-align: left">
                    {{ item.ProcessedAcknowledgement.Type }}
                  </td>
                  <td style="padding: 12px 5px !important; text-align: left">
                    {{ item.ParticipatCount }}
                  </td>
                </tr>
              </tbody>
            </table>
            <h5>NON-ENGLISH LANGUAGE SURVEY</h5>
            <div>
              <div *ngIf="processedDistributions[0]?.FewerThan100Participants">
                <b>Plans with fewer than 100 participants</b>
                <div>
                  Are 25% or more of all plan participants only literate in a
                  non-English language?
                  {{ processedDistributions[0]?.Can25PercentRead }}
                </div>
                <div
                  *ngIf="
                    processedDistributions[0]?.Can25PercentRead === 'No' &&
                    (!processedDistributions[0]?.MoreThan100Participants ||
                      (processedDistributions[0]?.MoreThan100Participants &&
                        processedDistributions[0]?.Can500Read === 'Yes'))
                  "
                >
                  A non-English survey is not required.
                </div>
                <div
                  *ngIf="processedDistributions[0]?.Can25PercentRead === 'Yes'"
                >
                  <div>
                    Total number of plan participants who read only the same
                    non-English language:
                    {{ processedDistributions[0]?.NumberWhoReadSmallPlan }}
                  </div>
                  <div>
                    What is the non-English language?
                    {{ processedDistributions[0]?.LanguageForSmallPlan }}
                  </div>
                </div>
              </div>
              <br />
              <div *ngIf="processedDistributions[0]?.MoreThan100Participants">
                <b>Plans with 100 or more participants</b>
                <div>
                  Are 500 or more of your plan participants literate only in a
                  non-English language?
                  {{ processedDistributions[0]?.Can500Read }}
                </div>
                <div *ngIf="processedDistributions[0]?.Can500Read === 'No'">
                  A non-English survey is not required.
                </div>
                <div *ngIf="processedDistributions[0]?.Can500Read === 'Yes'">
                  <div>
                    Are 10% or more of your plan participants literate only in a
                    non-English language?
                    {{ processedDistributions[0]?.Can10PercentRead }}
                  </div>
                  <div>
                    Total number of plan participants who read only the same
                    non-English language:
                    {{ processedDistributions[0]?.NumberWhoReadLargePlan }}
                  </div>
                  <div>
                    What is the non-English language?
                    {{ processedDistributions[0]?.LanguageForLargePlan }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
